import momentH from "moment-hijri";
import moment from 'moment';
moment.locale('en');

const currentMonthG = moment().month() + 1;
const currentDayG = moment().date();
const currentMonth = momentH().iMonth() + 1;
const currentDay = momentH().iDate();
export const isRamadan = currentMonth === 9;
export const isEidAlfitr = currentMonth === 10 && currentDay >= 1 && currentDay <= 5;
export const isEidAladha = currentMonth === 12 && currentDay >= 10 && currentDay <= 14;
export const isSaudiNationalDay = currentMonthG === 9 && currentDayG >= 22 && currentDayG <= 24;
// export const isSaudiNationalDay = currentMonthG === 3 && currentDayG >= 27 && currentDayG <= 31; // for testing purposes

// console.log(isSaudiNationalDay, currentMonthG, currentDayG);
